<div class="kz-projectV2">
  <div class="kz-projectV2-container">
    <div class="kz-projectV2-content">
      <form [formGroup]="kazaForm" (ngSubmit)="save()" class="kz-registerV2-form" novalidate appGtmTrack="dataChantier_form" trackChildren="false">
        <div  class="kz-registerV2-form-header">
          <div class="kz-registerV2-form-header-title">
            <h2 i18n="@@auth.kaza.title">Your house project</h2>
            <p i18n="@@auth.kaza.subTitle">Select the thumbnails that define your project</p>
          </div>
          <div *ngIf="isInKazaplan$ | async" class="kz-registerV2-from-plan">
            <kz-jumbotron jumbotronContext="warning">
              <h3 class="kz-light-title">
                <kz-icons name="infos" inline="true"></kz-icons>
                <ng-container i18n="@@auth.kaza.fromKazaplan">Finalize your registration to save your 3D plan</ng-container>
              </h3>
            </kz-jumbotron>
          </div>

        </div>

        <div *ngIf="loadingProjectTypes" class="kz-registerV2-loader">
          <kz-loader type="logo"></kz-loader>
        </div>


        <ul class="kz-projectV2--categories">
          <li *ngFor="let projectType of projectTypes; let i = index" class="kz-registerV2--category" [@fadeInAnimation] id="project-{{ projectType.type }}">
            <input class="kz-choice-grid-input" type="checkbox" id="kz-choice-{{ projectType.type }}" [formControl]="kazaForm.get('types')['controls'][i]" name="kz-choice-{{ projectType.type }}" (click)="changeProjectTypes(projectType)"/>
            <label class="kz-choice-grid-label" for="kz-choice-{{ projectType.type }}">
              <span kzBadge badgeType="certified" title="team kozikaza" [empty]="true"></span>
              <img *ngIf="projectType.type !== 'no-work'" src="{{ projectType.media.thumbs.big }}" alt="{{ projectType.name }}" height="120" />
              <img *ngIf="projectType.type === 'no-work'" src="/assets/images/registerv2/project-1f.jpg" alt="{{ projectType.name }}" height="120" />
              <span class="option-title">{{ projectType.name }}</span>
            </label>
          </li>
        </ul>

        <p *ngIf="isFieldInvalid('types')" kzError>
          <span i18n="@@auth.kaza.errors.missingProjectError">You must select a type of kaza / project (or no project)</span></p>
        <div class="kz-fields">
          <kz-field class="kz-field-half" [hasError]="isFieldInvalid('country')">
            <label kzLabel isRequired="true" for="kz-project--country" i18n="@@auth.kaza.country">Country</label>
            <ng-select formControlName="country" name="country" id="kz-project--country" [clearable]="false">
              <ng-option *ngFor="let country of countries" [value]="country.code">{{ country.name }}</ng-option>
            </ng-select>
            <p kzError *ngIf="kazaForm.get('country')?.errors?.required && isFieldInvalid('country')"><span i18n="@@auth.errors.required">Required</span></p>
          </kz-field>

          <kz-field class="kz-field-half" [hasError]="isFieldInvalid('postalCode')">
            <label kzLabel [isRequired]="kazaForm.get('country').value == 'FR'" for="kz-project--postal" i18n="@@auth.kaza.zipcode">Zip code</label>
            <input kzTextBox id="kz-project--postal" type="text" placeholder="Votre code postal" formControlName="postalCode"/>
            <p kzError *ngIf="kazaForm.get('postalCode')?.errors?.required && isFieldInvalid('postalCode')" i18n="@@auth.errors.required">Required</p>
            <p kzError *ngIf="!kazaForm.get('postalCode')?.errors?.required && kazaForm.get('postalCode')?.errors?.postalCodeValidError && isFieldInvalid('postalCode')"  i18n="@@auth.errors.invalid">This field is invalid</p>
          </kz-field>
        </div>

        <div class="kz-field-buttons">
          <button type="submit" kzButton buttonStyle="flat" [buttonState]="submitted ? 'loading' : 'default'" [disabled]="submitted" data-cy="submit"><span i18n="@@auth.button.next" appGtmTrack="dataChantier_save">Next</span></button>
        </div>
      </form>
    </div>
    <app-legal-notice [whiteTxt]="true"></app-legal-notice>
  </div>
</div>
